import { render, staticRenderFns } from "./almondco-inshell-current-lots.vue?vue&type=template&id=9bc43138"
import script from "./almondco-inshell-current-lots.vue?vue&type=script&lang=js"
export * from "./almondco-inshell-current-lots.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports